<button 
  [ngClass]="[getClassName(), 'btn']"
  (click)="execute()">
  <i [class]="getDynamicIconClass()"></i>
  {{ getTaskName() }}
</button>